var React = require('react');

function InfoBlockOutline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Information"),React.createElement("path",{"d":"M30 6a24 24 0 110 48 24 24 0 010-48zm0 3a21 21 0 110 42 21 21 0 010-42z","fillRule":"evenodd","key":1}),React.createElement("path",{"d":"M30 14.4c2 0 3.6 1.6 3.6 3.6a3.6 3.6 0 01-4.8 3.4 3.6 3.6 0 01-2.4-3.4c0-2 1.6-3.6 3.6-3.6zM35.6 44H24.4c-.2 0-.4-1.5-.4-2s.1-2 .4-2H28V29h-3.6l-.4-2c0-.5.1-2 .4-2H32v15h3.6c.2 0 .4 1.5.4 2s-.1 2-.4 2z","key":2})]);
}

InfoBlockOutline.defaultProps = {"viewBox":"0 0 60 60","id":"info-block","width":"100%","height":"100%"};

module.exports = InfoBlockOutline;

InfoBlockOutline.default = InfoBlockOutline;
